export default __webpack_public_path__ + "static/media/Icon14.2c426943.svg";